import { Stack, Typography, Divider } from '@mui/material';
import { BackupPolicyType } from '@repo/api-gw-sdk';

import { isPitrPolicyType, isStandardPolicyType } from './backupPoliciesTypes';
import { SupportedResourceTypesText } from './supportedResourceTypesText';
import { useBackupPolicyAvailableTypes } from './useBackupPolicyAvailableTypes';

export const BackupPolicySupportedDisclaimer = ({
  policyType,
}: {
  policyType: BackupPolicyType;
}) => {
  return (
    <>
      <Stack gap='2px'>
        <div />
        <Stack
          alignItems='center'
          className='bg-[var(--mui-palette-background-section)]'
        >
          <BackupPolicyTypeDescription policyType={policyType} />
        </Stack>
        <Divider />
      </Stack>
    </>
  );
};

export const BackupPolicyTypeDescription = ({
  policyType = BackupPolicyType.BACKUP_POLICY_TYPE_STANDARD,
  showForPitr = true,
}: {
  policyType?: BackupPolicyType;
  showForPitr?: boolean;
}) => {
  const resourceTypes = useBackupPolicyAvailableTypes()[policyType];

  if (
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY ||
    isStandardPolicyType(policyType)
  ) {
    return (
      <Stack gap='4px' direction='row' alignItems='center'>
        <Typography padding='12px 0px' align='center'>
          {`${policyType === BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY ? 'High-frequency' : 'Standard'} backup policy • Available for`}
        </Typography>
        <SupportedResourceTypesText resourceTypes={resourceTypes} />
      </Stack>
    );
  }

  if (showForPitr && isPitrPolicyType(policyType)) {
    return (
      <Typography
        padding='12px 40px'
        align='center'
        className='bg-[var(--mui-palette-background-section)]'
      >
        Point-in-time recovery backup policy.
      </Typography>
    );
  }

  return null;
};
